import DataOptionsSection from "../../../../src/pages/data-visualization/getting-started/shared-data-options-section";
import React from 'react';
export default {
  DataOptionsSection,
  React
};